import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { ApiEsService } from "./api-es.service";
import { SolarAccountEs } from "@edp-models/ES/es-solar-account.model";

@Injectable({
    providedIn: "root",
})
export class SolarAccountEsService {
    constructor(private apiEsService: ApiEsService) {}

    public get(): Observable<SolarAccountEs | Error> {
        return this.apiEsService.callServicePostToCollection("solar.services.account.getAccount", {}, null, false);
    }

    public update(args: { email: string } | { phone: string } | { mobilePhone: string }) {
        return this.apiEsService.callServicePostToCollection("solar.services.account.updateAccount", args, null, false);
    }
}
